import { Link } from "react-router-dom";

//import translation function for language translation
import { useTranslation } from "react-i18next";

const ActionLogBreadCrumb = () => {
  const { t } = useTranslation(); //for translation

  return (
    <nav aria-label="breadcrumb">
      <ul className="breadcrumb">
        <li className="breadcrumb-item">
          <Link to="/" className="text-secondary">
            Funbrain
          </Link>
        </li>
        <li className="breadcrumb-item text-gray-600" aria-current="page">
          {t("Action Logs")}
        </li>
      </ul>
    </nav>
  );
};

export default ActionLogBreadCrumb;
